import React, { lazy, Suspense } from "react";
import Login from "./Login";
import 'bootstrap/dist/css/bootstrap.css';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Routes, Route} from 'react-router-dom';
import Home from "./Home";
import Signup from "./Signup";
import Password from "./components/Password";
import Reportstillmonth from "./components/Reportstillmonth";
import Errorpage from "./components/Errorpage";
import Tcsreport from "./components/Tcsreport";
import Forgotpassword from "./components/Forgotpassword";
import Tcsinventory from "./components/Tcsinventory";
import Tcssoreport from "./components/Tcssoreport";
import Tcssaleshisreport from "./components/Tcssaleshisreport";
import MonthendReport from "./components/MonthendReport";
import AuthLogin from "./HOC/AuthLogin";
import Loaders from "./components/Spinners/Loaders";
import TicketList from "./components/TicketSystem/TicketList";
import TicketForm from "./components/TicketSystem/TicketForm";
import TicketDetail from "./components/TicketSystem/TicketDetail";
import Sapsoreport from "./components/Sapsoreport";

import Livesapsoreport from "./components/Livesapsoreport";
import Livesapzsmreport from "./components/Livesapzsmreport";
import Sapinventory from "./components/Sapinventory";










const App =() => {

  const Home = lazy(()=>import("../src/Home"));
  const Login = lazy(()=>import("../src/Login"));
  const Signup = lazy(()=>import("../src/Signup"));
  const Livesapsoreport = lazy(()=>import("../src/components/Livesapsoreport"));
  const Livesapzsmreport = lazy(()=>import("../src/components/Livesapzsmreport"));
  const Sapinventory = lazy(()=>import("../src/components/Sapinventory"));
  const Password = lazy(()=>import("../src/components/Password"));
  const Tcsinventory = lazy(()=>import("../src/components/Tcsinventory"));
  const Tcsreport = lazy(()=>import("../src/components/Tcsreport"));
  const Tcssoreport = lazy(()=>import("../src/components/Tcssoreport"));
  const Sapsoreport = lazy(()=>import("../src/components/Sapsoreport"));
  const Forgotpassword = lazy(()=>import("../src/components/Forgotpassword"));
  const TicketList = lazy(()=>import("../src/components/TicketSystem/TicketList"));
  const TicketForm = lazy(()=>import("../src/components/TicketSystem/TicketForm"));
  const TicketDetail = lazy(()=>import("../src/components/TicketSystem/TicketDetail"));
  
  return (
    <>
    
    <Suspense fallback={<Loaders />}>
    
    <Routes>      
      <Route exact path='/' element={<Login />}/>
      {/* <Route exact path='/Login' element={<Login />}/>       */}
      <Route exact path='/Home' element={<AuthLogin><Home /></AuthLogin>}/>
      <Route exact path='/Livesapsoreport' element={<AuthLogin><Livesapsoreport /></AuthLogin>}/>
      <Route exact path='/Livesapzsmreport' element={<AuthLogin><Livesapzsmreport /></AuthLogin>}/>
      <Route exact path='/Sapinventory' element={<AuthLogin><Sapinventory /></AuthLogin>}/>
      <Route exact path='/Signup' element={<AuthLogin><Signup /></AuthLogin>}/>
      <Route exact path='/Password' element={<AuthLogin><Password /></AuthLogin>}/>
      <Route exact path='/Reportstillmonth' element={<AuthLogin><Reportstillmonth /></AuthLogin>}/>
      <Route exact path='/Tcsreport' element={<AuthLogin><Tcsreport /></AuthLogin>}/>
      <Route exact path='/Tcssoreport' element={<AuthLogin><Tcssoreport /></AuthLogin>}/>
      <Route exact path='/Sapsoreport' element={<AuthLogin><Sapsoreport /></AuthLogin>}/>
      <Route exact path='/Tcssaleshisreport' element={<AuthLogin><Tcssaleshisreport /></AuthLogin>}/>      
      <Route exact path='/Tcsinventory' element={<AuthLogin><Tcsinventory /></AuthLogin>}/>
      <Route exact path='/Forgotpassword' element={<Forgotpassword />}/>
      <Route exact path='/MonthendReport' element={<AuthLogin><MonthendReport /></AuthLogin>}/>
      <Route exact path='/ticketlist' element={<AuthLogin><TicketList /></AuthLogin>}/>
      <Route exact path='/ticketcreate' element={<AuthLogin><TicketForm /></AuthLogin>}/>
      <Route exact path='/ticket/:id' element={<AuthLogin><TicketDetail /></AuthLogin>}/>

      <Route path="*" element={<Errorpage />} />
    </Routes>        
    </Suspense>
    
    <ToastContainer className="foo w-75" />
    </>
  );
}

export default App;
